module.exports = __webpack_public_path__ + "img/teammodelmail.664f7cdc.png";